import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['text'];

	show() {
		this.textTarget.classList.remove('hidden');
		// this.textTarget.classList.add('inline');
	}
	hide() {
		this.textTarget.classList.add('hidden');
	}
	showSmallScreen(e) {
		if (!this.textTarget.classList.contains('hidden')) {
			this.textTarget.classList.add('hidden');
			return;
		}

		//hiden open tooltip texts
		document.querySelectorAll('.tooltipText').forEach((tooltip) => {
			if (!tooltip.classList.contains('hidden')) {
				tooltip.classList.add('hidden');
			}
		});
		this.textTarget.classList.remove('hidden');
	}
}
